'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Pricing = function Pricing() {
    _classCallCheck(this, Pricing);

    require('../../../sass/pages/pricing.sass');
};

exports.default = Pricing;